import { HttpClient,HttpBackend,HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from, switchMap  } from 'rxjs';
import { map } from 'rxjs/operators'
import { EnvService } from '../../../core/env.service';
import { RuleAppliedPropertyDTO  } from '../../model/RuleAppliedPropertyDTO';
import { RuleAppliedDTO  } from '../../model/RuleAppliedDTO';
import {TestQueryBuilderFilterRule} from '../../model/TestQueryBuilderFilterRule';
import { FilterResultDTO } from '../../model/FilterResultDTO';
import { FilterDTO } from '../../model/FilterDTO';
import { OptionDTO } from '../../model/OptionDTO';
import { QueryBuilderFilterRuleDTO } from '../../model/QueryBuilderFilterRuleDTO';
import { AuthService } from '../../../core/auth-service.component';
import { SummaryDTO } from '../../model/SummaryDTO';

@Injectable({
    providedIn: 'root'
})
export class AutopassService {
    constructor(private _httpClient: HttpClient,public _env: EnvService,
        private _httpClientBackend: HttpClient,
        private _httpHandler: HttpBackend,private _authService: AuthService) {
        this._httpClientBackend = new HttpClient(_httpHandler); //using this var will now show the loader 
    }

    GetAutopassConditionColumns(): Observable<any> {
        return this._httpClient.get<any>(this._env.apiRule +'Autopass/GetAutopassConditionColumns')
            .pipe(map((res: any) => res));
    }

    GetReasonCodes(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetReasonCodes?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetAutopassConditionFields(): Observable<any> {
        return this._httpClient.get<Array<RuleAppliedPropertyDTO>>(this._env.apiRule +'Autopass/GetAutopassConditionFields')
            .pipe(map((res: any) => res));
    }

    GetUnAppliedRules(): Observable<Array<RuleAppliedPropertyDTO>> {
        return this._httpClient.get<Array<RuleAppliedPropertyDTO>>(this._env.apiRule +'Autopass/GetUnAppliedRules')
        .pipe(map((res: Array<RuleAppliedPropertyDTO>) => res));
    }
    GetCurrency(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCurrency?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCurrencyByFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCurrencyFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetInvoiceStatus(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetInvoiceRateStatus?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetInvoiceStatusByFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetInvoiceRateStatusFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    EditFilter(clientCode:string): Observable<Array<any>> {
        return this._httpClient.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/editFilter?clientCode='+clientCode)
        .pipe(map((res: Array<OptionDTO>) => res));
    }
    GetInvoiceIdsListDropDown(clientName:string,page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetInvoiceIds?clientName='+clientName+'&&page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetAllInvoiceIdsListDropDown(clientName:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetAllInvoiceIds?clientName='+clientName,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    // Client here ........

    GetClientId(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientId?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientIdByFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientIdByFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientCode(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCTClientName?page='+page+'&&pageSize='+pageSize, {headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)}).pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientCodeByFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCTClientNameByFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientRegion(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientRegion?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientRegionByFilter(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientRegionByFilter?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCTClientCountry(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientCountry?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCTClientCountryByFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientCountryFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCTClientCity(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCTClientCity?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCTClientCityByFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCTClientCityByFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientCity(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientCity?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCTClientParentName(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientParent?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCTClientParentNameByFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientParentByFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCTClientFullName(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientFullName?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCTClientFullNameByFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientFullNameByFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientDivision(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientDiv?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientDivisionFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientDivFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientSubDivision(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientSubDiv?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        })    )
    }

    GetClientSubDivisionFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientSubDivFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientLocation(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientLoc?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientLocationFilter(page:number, pageSize:number,filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientLocFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientSubLocation(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientSubLoc?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientSubLocationFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientSubLocFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientCountryCode(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientCountry?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientCountryCodeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientCountryFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientCountyCode(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientCounty?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientCountyCodeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetAllClientCountyFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetUOM(): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetUOM',{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    //Carrier here.............
    GetCarrierID(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCarrierId?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }

    GetCarrierIDFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCarrierIdFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierShortName(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCarrierShortName?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierShortNameFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCarrierShortNameFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierFullName(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCarrierFullName?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierFullNameFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCarrierFullNameFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierRegion(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCarrierRegion?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierRegionFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCarrierRegionFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierSCAC(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCarrierSCAC?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierSCACFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCarrierSCACFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierLocation(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCarrierLoc?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierLocationFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCarrierLocFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierSubLocation(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCarrierSubLoc?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierSubLocationFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCarrierSubLocFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierCurrency(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCarrierCurrency?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierCurrencyFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCarrierCurrencyFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierCountryCode(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCarrierCountry?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierCountryCodeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCarrierCountryFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierCity(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCarrierCity?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierCityFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCarrierCityFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierPostCode(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCarrierPostCode?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCarrierPostCodeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCarrierPostCodeFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientCarrierId(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientCarrierId?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientCarrierIdFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientCarrierIdFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientCarrierGP1(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientCarrierGP1?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientCarrierGP1Filter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientCarrierGP1Filter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientCarrierGP2(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientCarrierGP2?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetClientCarrierGP2Filter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetClientCarrierGP2Filter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetShipMode(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetShipmentMode?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetShipModeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetShipmentModeFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetSrvceType(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetServiceType?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetSrvceTypeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetServiceTypeFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetFreightTerm(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetFreightTerms?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetFreightTermFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetFreightTermsFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCountryCode(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCountry?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetCountryCodeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetCountryFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetGeoPortCode(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetPortCode?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetGeoPortCodeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetPortCodeFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    // GetGeoPostCode(page:number, pageSize:number): Observable<Array<OptionDTO>> {
    //     return from(this._authService.getAccessToken())
    //     .pipe(switchMap((token)=>
    //     {
    //         return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetPostCode?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
    //         .pipe(map((res: Array<OptionDTO>) => res));
    //     }))
    // }
    GetGeoPostCodeFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetPostCodeFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetShipmentOriginState(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetShipmentState?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetShipmentOriginStateFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetShipmentStateFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetShipmentCity(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetShipmentCity?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetShipmentCityFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetShipmentCityFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetAccessorialName(page:number, pageSize:number): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetAccessorial?page='+page+'&&pageSize='+pageSize,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetAccessorialNameFilter(page:number, pageSize:number, filter:string): Observable<Array<OptionDTO>> {
        return from(this._authService.getAccessToken())
        .pipe(switchMap((token)=>
        {
            return this._httpClientBackend.get<Array<OptionDTO>>(this._env.apiRule +'Autopass/GetAccessorialFilter?page='+page+'&&pageSize='+pageSize+'&&filter='+filter,{headers: new HttpHeaders().set('Authorization', `Bearer ${token}`)})
            .pipe(map((res: Array<OptionDTO>) => res));
        }))
    }
    GetAppliedRulesByFilterId(filterId:Number): Observable<Array<RuleAppliedDTO>> {
        return this._httpClient.get<Array<RuleAppliedDTO>>(this._env.apiRule +'Autopass/GetAppliedRulesByFilterId?filterId='+filterId)
        .pipe(map((res: Array<RuleAppliedDTO>) => res));
    }
    GetFilterById(id: Number) {
        return this._httpClient.get<FilterDTO>(this._env.apiRule +'Autopass/GetFilterById?id='+id)
        .pipe(map((res: FilterDTO) => res)); 
    }

    GetFilterLineWithChildAutopass(id: Number) {
        return this._httpClient.get<any>(this._env.apiRule +'Autopass/GetFilterLineByIdAutopass?id='+id)
        .pipe(map((res: any) => res));
    }


    GetFilterLineWithChild(id: Number) {
        return this._httpClient.get<any>(this._env.apiRule +'Autopass/GetFilterLineById?id='+id)
        .pipe(map((res: any) => res));
    }
    
    GetFilterLineByFilterId(id: Number) {
        return this._httpClient.get<any>(this._env.apiRule +'Autopass/GetFilterLineByFilterId?id='+id)
        .pipe(map((res: any) => res));
    }

    SaveFilter(data:QueryBuilderFilterRuleDTO): Observable<any> {
        return this._httpClient.post<QueryBuilderFilterRuleDTO>(this._env.apiRule +'Autopass/SaveFilter',data)
        .pipe(map((res: any) => res));
    }

    SaveAutopass(data: string): Observable<any> {
        return this._httpClient.post<QueryBuilderFilterRuleDTO>(this._env.apiRule +'Autopass/SaveAutoPass',data)
        .pipe(map((res: any) => res));
    }

    TestRules(data:TestQueryBuilderFilterRule): Observable<TestQueryBuilderFilterRule> {
        return this._httpClient.post<TestQueryBuilderFilterRule>(this._env.apiRule +'Autopass/GetInvoicesByIds',data).pipe(map((res: TestQueryBuilderFilterRule) => res));
    }

    GetFilterByClient( page:number,pageSize:number,clientCode:string ){
        return this._httpClient.get<any>(this._env.apiRule +'Autopass/GetFilterByClient?page='+page+'&&pageSize='+pageSize+'&&clientCode='+clientCode)
        .pipe(map((res: any) => res));
    }
    
    GetExportRule(data:any): Observable<any> {
        return this._httpClient.post<any>(this._env.apiRule +'Autopass/GetExportRule',data)
        .pipe(map((res: any) => res));
    }

    GetExportRuleListAutopass(data:any): Observable<any> {
        return this._httpClient.post<any>(this._env.apiRule +'Autopass/GetExportRuleListAutopass',data)
        .pipe(map((res: any) => res));
    }

    //shipments here
    GetAllAccessorial():Observable<any> {
        return this._httpClient.get<any>(this._env.apiRule +'Autopass/GetAllAccessorial')
        .pipe(map((res: any) => res));
    }
    GetClientField(clientCode:string):Observable<any> {
        return this._httpClient.get<any>(this._env.apiRule +'Autopass/GetClientField?clientCode='+clientCode)
        .pipe(map((res: any) => res));
    }
    GetSID():Observable<any> {
        return this._httpClient.get<any>(this._env.apiRule +'Autopass/GetSID')
        .pipe(map((res: any) => res));
    }
    ManualTest(data:any): Observable<any> {
        return this._httpClient.post<any>(this._env.apiRule +'Autopass/ManualTest',data)
        .pipe(map((res: any) => res));
    }
    DeleteAutopassRules(data:any): Observable<any> {
        return this._httpClient.post<any>(this._env.apiRule +'Autopass/DeleteAutopassRules',data)
        .pipe(map((res: any) => res));
    }
    DeleteRules(data:any): Observable<any> {
        return this._httpClient.post<any>(this._env.apiRule +'Autopass/DeleteRules',data)
        .pipe(map((res: any) => res));
    }
    DisplaySummaryCount(data:SummaryDTO): Observable<any> {
        return this._httpClient.post<any>(this._env.apiRule +'Autopass/SummaryCount',data)
        .pipe(map((res: any) => res));
    }
    GetFilterByFilterId(filterIds:string):Observable<any> {
        return this._httpClient.get<any>(this._env.apiRule +'Autopass/GetFilterByFilterId?filterIds='+filterIds)
        .pipe(map((res: any) => res));
    }

    SaveTemplate(data:any): Observable<any> {
        return this._httpClient.post<any>(this._env.apiRule +'Autopass/SaveTemplate',data)
        .pipe(map((res: any) => res));
    }

    UpdateTemplate(data:any): Observable<any> {
        return this._httpClient.post<any>(this._env.apiRule +'Autopass/UpdateTemplate',data)
        .pipe(map((res: any) => res));
    }

    GetTemplate(page:number, pageSize:number, filter:string){
        return this._httpClient.get<any>(this._env.apiRule +'Autopass/GetTemplate?pageNo='+page+'&&pageSize='+pageSize+'&&filter='+filter)
        .pipe(map((res: any) => res));
    }

    GetTemplateByName( name:string){
        return this._httpClient.get<any>(this._env.apiRule +'Autopass/GetTemplateByName?name='+name)
        .pipe(map((res: any) => res));
    }

    DeleteTemplate(data:any): Observable<any> {
        return this._httpClient.get<any>(this._env.apiRule +'Autopass/DeleteTemplate?name='+data)
        .pipe(map((res: any) => res));
    }
}